var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTracking = function SvgTracking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 29,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M26.295 13.248c0 4.626-4.705 11.906-11.089 19.595a2.543 2.543 0 0 1-3.918 0C4.905 25.152.199 17.873.199 13.247.2 6.042 6.041.202 13.247.202c7.207 0 13.048 5.84 13.048 13.046zm-2 0c0-6.102-4.945-11.046-11.048-11.046C7.145 2.202 2.2 7.146 2.2 13.248c0 3.933 4.621 11.081 10.627 18.316.222.267.62.267.842 0 6.007-7.235 10.627-14.383 10.627-18.316zm-4.405 0a6.64 6.64 0 0 1-6.642 6.642 6.642 6.642 0 1 1 6.642-6.642zm-2 0a4.642 4.642 0 1 0-9.284 0 4.642 4.642 0 0 0 9.284 0z"
  })))));
};
export default SvgTracking;